{
  "UnifiedNavigation": "Naviguez dans Experience Cloud",
  "adobeExperienceCloudNoOrgsSelect": "Sélectionner le compte d’une autre organisation",
  "help": "Aide",
  "profile": "Profil",
  "searchButton": "Rechercher",
  "sidenavMenuCloseTooltip": "Fermer le menu",
  "sidenavMenuOpenTooltip": "Ouvrir le menu",
  "solutionSwitcher": "Passer à une autre solution",
  "toggleSideNav": "Basculer vers le menu de navigation latéral"
}
